/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Time } from '@wit/vtv-x-foundation-lib';
import { ChannelFilter } from 'store/ducks/watchTv/channelFilters';

export enum WatchTvSection {
  ON_NOW = 'On Now',
  TV_GUIDE = 'Tv Guide',
}

export interface WatchTvWrapperProps {
  overlay?: boolean;
  setShowWrapper?: (arg: boolean) => void;
}

export interface WatchTvBarProps {
  setFilter: (filter: ChannelFilter) => void;
  section: WatchTvSection;
  setSection: (arg: WatchTvSection) => void;
  overlay?: boolean;
  setShowWrapper?: (arg: boolean) => void;
  selectedDay: Time;
  setSelectedDay: (arg: Time) => void;
}
